<template>
  <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
  <div>Page not found !</div>
</template>

<script>
export default {
  name: 'Home'
};
</script>